import i18n from "../i18n";

export const AREA_UNITS = [
  { value: "fed", label: "Feddan", short: "feddan" },
  { value: "ha", label: "Hectare (ha)", short: "ha" },
  { value: "acre", label: "Acre", short: "acres" },
  { value: "m2", label: "Square meter (m²)", short: "m²" },
  { value: "km2", label: "Square kilometer (km²)", short: "km²" },
];

// default when no unit is sent.
export const DEFAULT_AREA_UNIT = "fed";

export const getAreaUnit = (value) =>
  AREA_UNITS.find((unit) => unit.value === value) ||
  AREA_UNITS.find((unit) => unit.value === DEFAULT_AREA_UNIT);

// The unit's short name in the current language ("feddan", "فدان").
export const areaUnitShort = (value) =>
  i18n.t(`units.${getAreaUnit(value).value}.short`);

export const formatArea = (value, unitValue, { withUnit = true } = {}) => {
  if (value === undefined || value === null || value === "") return "-";
  // formatter's default cuts to 3 decimals
  const number = Number(value).toLocaleString("en-US", {
    maximumFractionDigits: 20,
  });
  return withUnit ? `${number} ${areaUnitShort(unitValue)}` : number;
};
